// Port of `CompilePipeline.numberWords` (SuiteCompile/Pipeline.swift): NumberFormatter's English spell-out (ICU's
// %spellout-numbering → %spellout-cardinal rules for "en"), then each word capitalised: 14 → "Fourteen",
// 21 → "Twenty-One", 101 → "One Hundred One".

const ONES = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve',
  'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
const TENS = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
const SCALES: [number, string][] = [[1e15, 'quadrillion'], [1e12, 'trillion'], [1e9, 'billion'], [1e6, 'million'], [1000, 'thousand'], [100, 'hundred']];

/** ICU's English cardinal spell-out of an integer, lower case. */
export function spellOut(n: number): string {
  if (!Number.isFinite(n)) return String(n);
  n = Math.trunc(n);
  if (n < 0) return 'minus ' + spellOut(-n);
  if (n >= 1e18) return n.toLocaleString('en');
  if (n < 20) return ONES[n];
  if (n < 100) return TENS[Math.floor(n / 10)] + (n % 10 ? '-' + ONES[n % 10] : '');
  for (const [scale, name] of SCALES) {
    if (n >= scale) {
      const rest = n % scale;
      return `${spellOut(Math.floor(n / scale))} ${name}` + (rest ? ' ' + spellOut(rest) : '');
    }
  }
  return String(n);
}

const capitalise = (parts: string[]) => parts.map((p) => (p === '' ? p : p[0].toUpperCase() + p.slice(1)));

/** `CompilePipeline.numberWords`. */
export function numberWords(n: number): string {
  const spelled = spellOut(n);
  // `.split(separator: "-")` then `.split(separator: " ")`, each piece capitalised (empty pieces dropped, as split does).
  const hyphens = capitalise(spelled.split('-').filter((p) => p !== '')).join('-');
  return capitalise(hyphens.split(' ').filter((p) => p !== '')).join(' ');
}
